import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid2,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useCallback, useEffect, useMemo, useState } from "react";
import HttpService from "../../../Hooks/Https-services";
import { APIRoutes } from "../../../Utils/constant";
import HighlightPlayer, {
  HighlightPlayerPersonalized,
} from "../../../Components/VideoPlayer";
import { useLoadData } from "../../../Context/LoadDataContext";
import useConfig from "../../../Hooks/useConfig";
import { LoadingButton } from "@mui/lab";
interface Team {
  team_id: string;
  team_name: string;
}

interface Player {
  player_id: string;
  player_first_name: string;
  player_last_name: string;
  team_id: string;
}

interface Event {
  id: string;
  name: string;
}

const PersonalizedChannel = () => {
  const [teams, setTeams] = useState<Team[]>([]);
  const [selectedTeams, setSelectedTeams] = useState<Team[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [selectedSeasons, setSelectedSeasons] = useState<any[]>([]);
  const [videoClipsData, setVideoClipsData] = useState<any>(null);
  const [players, setPlayers] = useState<Player[]>([]);
  console.log(players);
  const [selectedPlayers, setSelectedPlayers] = useState<Player[]>([]);
  const [events] = useState<Event[]>([
    { id: "1", name: "GOAL" },
    { id: "2", name: "FACE_OFF" },
    { id: "3", name: "HIT" },
    { id: "4", name: "PASS" },
    { id: "5", name: "SHOT" },
    { id: "6", name: "SHIFT" },
    { id: "7", name: "PENALTY" },
    { id: "8", name: "SAVE" },
  ]);
  const [seasons, setSeasons] = useState<any>([]);
  const [selectedEvents, setSelectedEvents] = useState<Event[]>([]);
  const [activeClip, setActiveClip] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { playerRef } = useLoadData();
  const { api } = useConfig();
  const GetAllPlayers = useCallback(async () => {
    setIsLoading(true);
    if (selectedTeams.length === 0) {
      setIsLoading(false);
      return;
    }
    try {
      const query = {
        team_ids: selectedTeams.map((team) => team.team_id).join(","),
        limit: "10000",
      };
      const res = await HttpService.get(
        APIRoutes.GetAllPlayers + `?${new URLSearchParams(query).toString()}`,
      );
      setPlayers(res.data.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }, [selectedTeams]);
  const GetAllSeasons = useCallback(async () => {
    try {
      const res = await HttpService.getAdmin(APIRoutes.GetSeasons);
      if (res) {
        setSeasons(res.data.data);
      }
    } catch (error) {}
  }, []);

  const GetAllTeams = useCallback(async () => {
    setIsLoading(true);
    try {
      const query = {
        limit: "10000",
      };
      const res = await HttpService.get(
        APIRoutes.GetAllTeams + `?${new URLSearchParams(query).toString()}`,
      );
      setTeams(res.data.data);
    } catch (error) {
      console.log(error);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    GetAllTeams();
    GetAllSeasons();
  }, [GetAllTeams, GetAllSeasons]);

  useEffect(() => {
    GetAllPlayers();
  }, [GetAllPlayers]);
  // Create a map of team_id to team_name for efficient lookup
  const teamMap = useMemo(() => {
    return teams.reduce(
      (acc, team) => {
        acc[team.team_id] = team.team_name;
        return acc;
      },
      {} as Record<string, string>,
    );
  }, [teams]);

  // Sort and organize players by team
  const sortedPlayers = useMemo(() => {
    return players
      ?.map((el: any) => {
        return el?.players;
      })
      ?.flat()
      ?.sort((a: any, b: any) => {
        const teamA = teamMap[a.team_id] || "Unknown Team";
        const teamB = teamMap[b.team_id] || "Unknown Team";
        if (teamA !== teamB) {
          return teamA.localeCompare(teamB);
        }
        return `${a.player_first_name} ${a.player_last_name}`.localeCompare(
          `${b.player_first_name} ${b.player_last_name}`,
        );
      });
  }, [players, teamMap]);
  const findCurrentClipTime = (el: any, index: any) => {
    let sum = 0;
    for (var i = 0; i < index; i++) {
      sum += parseFloat(videoClipsData?.list[i].duration) + 2;
    }
    return sum;
  };

  const handleSearch = useCallback(async () => {
    try {
      setLoading(true);
      const query = {
        team_names: selectedTeams.map((team) => team.team_name).join(","),
        player_names: selectedPlayers
          .map(
            (player) =>
              `${player.player_first_name} ${player.player_last_name}`,
          )
          .join(","),
        event_types: selectedEvents.map((event) => event.name).join(","),
        page: page.toString(),
        seasons: selectedSeasons.map((season) => season.season_id).join(","),
        limit: "10",
      };
      const res = await HttpService.get(
        APIRoutes.GetAllVideoClips +
          `?${new URLSearchParams(query).toString()}`,
      );
      setActiveClip(res.data.data?.list[0]?.game_event_id);
      setVideoClipsData(res.data.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [selectedTeams, selectedPlayers, selectedEvents, page, selectedSeasons]);
  console.log(selectedSeasons);
  const handlePrevious = useCallback(async () => {
    console.log("Previous");
    setPage(page - 1);
    handleSearch();
  }, [page, handleSearch]);
  const handleNext = useCallback(async () => {
    console.log("Next");
    setPage(page + 1);
    handleSearch();
  }, [page, handleSearch]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        p: 2,
        "& .MuiAutocomplete-root": {
          minWidth: 250,
          maxWidth: "100%",
        },
      }}
    >
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Autocomplete
          multiple
          id="teams-select"
          options={seasons}
          disableCloseOnSelect
          getOptionLabel={(option) => option.season_name}
          value={selectedSeasons}
          onChange={(_, newValue) => {
            setSelectedSeasons(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Seasons"
              placeholder="Seasons"
              sx={{ minWidth: 250 }}
            />
          )}
        />

        <Autocomplete
          multiple
          id="teams-select"
          options={teams}
          disableCloseOnSelect
          getOptionLabel={(option) => option.team_name}
          value={selectedTeams}
          onChange={(_, newValue) => {
            // Find removed teams by comparing old and new selection
            const removedTeams = selectedTeams.filter(
              (team) => !newValue.find((t) => t.team_id === team.team_id),
            );

            // Remove players from deselected teams
            const updatedSelectedPlayers = selectedPlayers.filter(
              (player) =>
                !removedTeams.find((team) => team.team_id === player.team_id),
            );

            setSelectedTeams(newValue);
            setSelectedPlayers(updatedSelectedPlayers);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Teams"
              placeholder="Teams"
              sx={{ minWidth: 250 }}
            />
          )}
        />

        <Autocomplete
          multiple
          disabled={selectedTeams.length === 0}
          id="players-select"
          options={sortedPlayers}
          disableCloseOnSelect
          getOptionLabel={(option) =>
            `${option.player_first_name} ${option.player_last_name}`
          }
          groupBy={(option) => teamMap[option.team_id] || "Unknown Team"}
          value={selectedPlayers}
          onChange={(_, newValue) => setSelectedPlayers(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Players"
              placeholder={
                selectedTeams.length === 0 ? "Select teams first" : "Players"
              }
              sx={{ minWidth: 250 }}
            />
          )}
          renderOption={(props, option) => (
            <li {...props} key={option.player_id}>
              {`${option.player_first_name} ${option.player_last_name}`}
            </li>
          )}
          ListboxProps={{
            style: { maxHeight: "400px" },
          }}
        />

        <Autocomplete
          multiple
          id="events-select"
          options={events}
          disableCloseOnSelect
          getOptionLabel={(option) => option.name}
          value={selectedEvents}
          onChange={(_, newValue) => setSelectedEvents(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Select Events"
              placeholder="Events"
              sx={{ minWidth: 250 }}
            />
          )}
          ListboxProps={{
            style: { maxHeight: "400px" },
          }}
        />
        <LoadingButton
          variant="contained"
          disabled={loading || !selectedTeams.length}
          sx={{ mt: 2, minWidth: 250 }}
          onClick={() => {
            handleSearch();
          }}
        >
          Search
        </LoadingButton>
      </Box>
      {videoClipsData && (
        <Box>
          <Grid2 container spacing={2}>
            <Grid2 size={{ xs: 12, md: 8 }}>
              <HighlightPlayerPersonalized
                url={`${api}/v1/assembly?event_ids=${videoClipsData?.list
                  ?.map((el: any) => el?.game_event_id)
                  .join(",")}&bypass=true`}
                videoList={videoClipsData?.list}
                setActiveClip={setActiveClip}
                findCurrentClipTime={findCurrentClipTime}
              />
            </Grid2>
            <Grid2 size={{ xs: 12, md: 4 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  bgcolor: "primary.main",
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="contained"
                  disabled={videoClipsData?.isFirstPage || loading}
                  onClick={handlePrevious}
                >
                  Previous
                </Button>
                <Button
                  variant="contained"
                  disabled={videoClipsData?.isLastPage || loading}
                  onClick={handleNext}
                >
                  Next
                </Button>
              </Box>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {loading ? (
                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <CircularProgress />
                  </Box>
                ) : (
                  videoClipsData?.list?.map((video: any, index: any) => (
                    <Box
                      onClick={() => {
                        playerRef.current.seek(
                          findCurrentClipTime(video, index),
                        );
                      }}
                      key={video.game_event_id}
                      sx={{
                        border:
                          activeClip === video.game_event_id
                            ? "1px solid red"
                            : "1px solid #e0e0e0",
                      }}
                    >
                      <Typography sx={{ px: 2, textAlign: "center" }}>
                        {video.event_type}
                      </Typography>
                      <Divider />
                      <Box
                        sx={{
                          display: "flex",

                          flexDirection: "column",
                          p: 1,
                          alignItems: "center",
                        }}
                      >
                        <Typography>{video.game_date}</Typography>
                        <Box sx={{ display: "flex", gap: 2 }}>
                          <Typography>{video.away_team_name}</Typography>
                          <Typography>AT</Typography>
                          <Typography>{video.home_team_name}</Typography>
                        </Box>
                      </Box>
                    </Box>
                  ))
                )}
              </Box>
            </Grid2>
          </Grid2>
        </Box>
      )}
    </Box>
  );
};

export default PersonalizedChannel;
